import { Builder } from '@builder.io/sdk';
import { ProductLinks } from './ProductLinks';
import { iconInput } from '../Icon/Icon.registry';
import { BuilderInputOptions } from '@/types/builder';

const ProductLinksConfig = {
  name: 'ProductLinks',
  inputs: [
    {
      name: 'heading',
      type: 'string',
    },
    {
      name: 'ctaText',
      type: 'string',
      required: false,
    },
    {
      name: 'isExternalLink',
      type: 'boolean',
      required: false,
      defaultValue: false,
      helperText: 'If true, the link will open a standard href, instead of an uploaded file.',
    },
    {
      name: 'ctaLink',
      type: 'string',
      required: false,
      showIf: (options: BuilderInputOptions) => !!options.get('isExternalLink'),
    },
    {
      name: 'fileLink',
      type: 'file',
      required: false,
      showIf: (options: BuilderInputOptions) => !options.get('isExternalLink'),
    },
    iconInput({
      name: 'ctaIcon',
      helperText: 'Icon for the CTA link',
    }),
    {
      name: 'items',
      type: 'list',
      subFields: [
        {
          name: 'text',
          type: 'string',
          required: true,
        },
        {
          name: 'link',
          type: 'string',
          required: true,
        },
        {
          name: 'selected',
          type: 'boolean',
          required: false,
          defaultValue: false,
        },
        iconInput({
          name: 'icon',
          helperText: 'Icon for the link',
        }),
      ],
    },
  ],
};

Builder.registerComponent(ProductLinks, ProductLinksConfig);
